import {
  REDEEM_LOYALTY_POINTS_FAILED,
  REDEEM_LOYALTY_POINTS_INVALID_REQ,
  REDEEM_LOYALTY_POINTS_SUCCESS,
  RESET_REDEEM_LOYALTY_POINTS,
  NETWORK_ERROR_LOYALTY_POINTS,
  LOADING_REDEEM,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  networkError: "",
  data: {},
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_REDEEM:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        networkError: "",
      };
    case REDEEM_LOYALTY_POINTS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: true,
        networkError: "",
        status: "You do not have enough loyalty points to redeem",
        data: action.payload,
      };
    case REDEEM_LOYALTY_POINTS_INVALID_REQ:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        networkError: "",
        status: "Something went wrong",
        data: action.payload,
      };
    case REDEEM_LOYALTY_POINTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: action.payload,
      };

    case NETWORK_ERROR_LOYALTY_POINTS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        networkError: "Something went wrong..",
      };

    case RESET_REDEEM_LOYALTY_POINTS:
      return (state = initialState);

    default:
      return state;
  }
};
